module.exports = __webpack_public_path__ + "img/kairan.5cc04df6.png";